import React, { JSX, useState } from "react";
import { Outlet } from "react-router";
import {
    EventSearchContext,
    EventSearchCriteria,
    defaultEventSearchCriteria,
} from "utilities/contexts/search/event/event-search-context";

interface AdminEventLayoutProps {}

const AdminEventLayout: React.FC<AdminEventLayoutProps> = (): JSX.Element => {
    const [eventSearchCriteria, setEventSearchCriteria] = useState<EventSearchCriteria>(
        defaultEventSearchCriteria
    );

    return (
        <EventSearchContext.Provider
            value={{ initialCriteria: eventSearchCriteria, setCriteria: setEventSearchCriteria }}>
            <Outlet />
        </EventSearchContext.Provider>
    );
};

export { AdminEventLayout };
